import { api } from './client';
import type { ManagedUser } from '../types';

export function listUsers(): Promise<{ users: ManagedUser[] }> {
  return api('/api/admin/users');
}

export function inviteUser(body: {
  email: string;
  display_name: string;
  role: 'owner' | 'editor' | 'viewer';
  mode: 'temp_password' | 'invite_link';
}): Promise<{
  user: { id: string; email: string; display_name: string; role: string };
  temp_password: string | null;
  invite_url: string | null;
}> {
  return api('/api/admin/users', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function patchUser(
  id: string,
  body: { display_name?: string; role?: 'owner' | 'editor' | 'viewer' },
): Promise<{ ok: true }> {
  return api(`/api/admin/users/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function revokeUser(id: string): Promise<{ ok: true }> {
  return api(`/api/admin/users/${id}/revoke`, { method: 'POST' });
}

export function reinstateUser(id: string): Promise<{ ok: true }> {
  return api(`/api/admin/users/${id}/reinstate`, { method: 'POST' });
}

export function adminResetPassword(
  id: string,
): Promise<{ temp_password: string }> {
  return api(`/api/admin/users/${id}/reset-password`, { method: 'POST' });
}

export function deleteUser(id: string): Promise<{ ok: true }> {
  return api(`/api/admin/users/${id}`, { method: 'DELETE' });
}

export function changeMyPassword(
  currentPassword: string,
  newPassword: string,
): Promise<{ ok: true }> {
  return api('/api/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({
      current_password: currentPassword,
      new_password: newPassword,
    }),
  });
}

export function getInviteInfo(
  token: string,
): Promise<{ email: string; display_name: string }> {
  return api(`/api/auth/accept-invite?token=${encodeURIComponent(token)}`);
}

export function acceptInvite(
  token: string,
  password: string,
): Promise<{ ok: true }> {
  return api('/api/auth/accept-invite', {
    method: 'POST',
    body: JSON.stringify({ token, password }),
  });
}
